<template>
  <div class="home-page">
    <section ref="app" id="app" class="app">
      <div class="container">
        <div class="app-row">
          <div class="app-img animate__animated animate__slideInLeft">
            <div class="app-img-content">
              <img src="@/assets/img/main/app.png" alt="картинка телефона">
            </div>
            <div class="app-img-shadow">
              <img src="@/assets/img/main/app-shadow.png" alt="тень картинки телефона">
            </div>
          </div>
          <div class="app-desc">
            <h2 class="animate__animated animate__slideInRight"><span>Ordagen</span> мобилді қосымшасының жаңа нұсқасы!</h2>
            <p class="animate__animated animate__slideInRight">Енді сүйікті ертегілеріңізді үйде, тіпті жолда интернетсіз оқып, тыңдауға болады!</p>
            <div class="app-link-wrapper animate__animated animate__slideInRight">
              <a class="app-link" target="_blank" href="https://play.google.com/store/apps/details?id=com.ordagen">
                <img src="@/assets/img/main/googleplay.svg" alt="картинка google play">
              </a>
              <a class="app-link" target="_blank" href="https://apps.apple.com/us/app/ordagen/id1526116038">
                <img src="@/assets/img/main/appstore.svg" alt="картинка appstore">
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section ref="about" id="about" class="promo">
      <div class="container">
        <div class="promo-row">
          <h2 class="visually-hidden">Ордаген</h2>
          <div class="promo-item">
            <ul>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.66665 19.1666V26.8333" stroke="#FDA321" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M15.3333 11.5V34.5" stroke="#FDA321" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M23 5.75V40.25" stroke="#FDA321" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M30.6666 11.5V34.5" stroke="#FDA321" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M38.3333 19.1666V26.8333" stroke="#FDA321" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
                <p>Аудио форматтағы жүздеген әңгімелер</p>
              </li>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M10.0625 10.0625C10.0625 5.56404 13.7099 1.91663 18.2083 1.91663V1.91663C22.7067 1.91663 26.3542 5.56404 26.3542 10.0625"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M26.8333 22.9999V19.6458C26.8333 18.0588 25.5453 16.7708 23.9583 16.7708V16.7708C22.3713 16.7708 21.0833 18.0588 21.0833 19.6458"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M26.8333 21.5625C26.8333 19.9755 28.1213 18.6875 29.7083 18.6875V18.6875C31.2953 18.6875 32.5833 19.9755 32.5833 21.5625V24.9167"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M21.0833 23V10.0625C21.0833 8.4755 19.7953 7.1875 18.2083 7.1875V7.1875C16.6213 7.1875 15.3333 8.4755 15.3333 10.0625V26.8333L11.7223 23.2223C10.5417 22.0417 8.62498 22.0417 7.44432 23.2223V23.2223C6.45915 24.2075 6.30582 25.7504 7.07823 26.91L13.8364 37.0453C15.9697 40.2443 19.5596 42.1667 23.4044 42.1667H26.8333C33.1852 42.1667 38.3333 37.0185 38.3333 30.6667V23.4792C38.3333 21.8922 37.0453 20.6042 35.4583 20.6042V20.6042C33.8713 20.6042 32.5833 21.8922 32.5833 23.4792"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p>Кітапқа тапсырыс беру бұрынғыдан да жеңіл</p>
              </li>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M5.7428 36.4223V36.4223C5.74386 32.2725 9.10761 28.9088 13.2573 28.9077H20.7719C24.9216 28.9088 28.2854 32.2725 28.2864 36.4223V36.4223"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M37.7434 9.57776C41.0951 12.9295 41.0951 18.3636 37.7434 21.7153" stroke="#FDA321"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M32.0428 12.6132C33.7186 14.289 33.7186 17.0061 32.0428 18.6819" stroke="#FDA321"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <ellipse cx="17.0137" cy="16.2889" rx="6.23176" ry="6.23176" stroke="#FDA321" stroke-width="3"
                           stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p>Балаңыз сіз дыбыстаған ертегілерді тыңдай алады</p>
              </li>
            </ul>
            <img src="@/assets/img/main/screens.png" alt="фото скриншота приложения">
          </div>
          <div class="promo-item">
            <img src="@/assets/img/main/screens-2.png" alt="фото скриншота приложения">
            <ul>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M29.7678 27.3623H28.2095C27.7821 27.3623 27.3911 27.6038 27.2013 27.9852L25.7619 30.8641C25.5549 31.28 24.9608 31.28 24.7538 30.8641L21.2328 23.8203C21.0278 23.4121 20.4489 23.4025 20.2323 23.805L18.63 26.7701C18.4326 27.1342 18.0512 27.3623 17.6372 27.3623H16.2323"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M9.42809 23H7.66859C5.21142 23 3.38867 25.2808 3.92917 27.6766L5.22675 33.4266C5.62159 35.1746 7.17409 36.4166 8.96617 36.4166H11.2585C11.8738 36.4166 12.328 35.8474 12.1938 35.2475L9.7175 24.2822C7.79509 15.7665 14.2696 7.66663 23 7.66663V7.66663V7.66663C31.7304 7.66663 38.2049 15.7665 36.2825 24.2822L33.8081 35.2475C33.672 35.8474 34.1282 36.4166 34.7415 36.4166H37.0338C38.8259 36.4166 40.3784 35.1746 40.7733 33.4266L42.0708 27.6766C42.6113 25.2808 40.7886 23 38.3314 23H36.5719"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p>Сүйікті ертегілеріңізді оффлайн да тыңдауға болады</p>
              </li>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M31.6286 35.4635V39.2984C31.6286 39.8279 31.1994 40.2572 30.6699 40.2572H15.3301C14.8007 40.2572 14.3714 39.8279 14.3714 39.2984V35.4635"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <rect x="8.61902" y="10.5364" width="28.762" height="24.927" rx="3" stroke="#FDA321" stroke-width="3"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M15.3301 10.5365V8.619C15.3301 7.03052 16.6179 5.7428 18.2063 5.7428H27.7937C29.3821 5.7428 30.6699 7.03052 30.6699 8.619V10.5365"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M17.9993 26.5435C19.2672 27.9749 21.0878 28.7944 23 28.7944C24.9122 28.7944 26.7328 27.9749 28.0008 26.5435"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M27.5003 20.3001C27.4369 20.3001 27.3761 20.3254 27.3315 20.3704C27.2868 20.4154 27.262 20.4764 27.2625 20.5398C27.2625 20.6369 27.3211 20.7244 27.4109 20.7614C27.5007 20.7984 27.604 20.7775 27.6724 20.7086C27.7408 20.6396 27.7608 20.5362 27.7231 20.4467C27.6854 20.3572 27.5974 20.2993 27.5003 20.3001"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M18.4978 20.3001C18.3654 20.3001 18.2581 20.4074 18.2581 20.5398C18.2581 20.6722 18.3654 20.7795 18.4978 20.7795C18.6302 20.7795 18.7375 20.6722 18.7375 20.5398C18.7375 20.4074 18.6302 20.3001 18.4978 20.3001"
                      stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p>Әр балаға жеке аккаунт</p>
              </li>
              <li>
                <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M25.3566 24.1158C25.5059 24.0487 25.6807 24.0745 25.8043 24.182C25.9278 24.2895 25.9776 24.459 25.9318 24.6162C25.6224 25.8114 24.9995 26.9023 24.1275 27.7762C22.4274 29.5008 19.9334 30.1821 17.5926 29.5614C15.2518 28.9407 13.4232 27.1132 12.8011 24.7727C12.1789 22.4323 12.8587 19.9379 14.5823 18.2368C15.455 17.3646 16.5455 16.7422 17.7404 16.4344C17.8955 16.3896 18.0625 16.4381 18.1695 16.559C18.2764 16.6799 18.3042 16.8516 18.2409 17.0001C17.2086 19.0421 17.6045 21.5162 19.2225 23.1342C20.8404 24.7521 23.3145 25.148 25.3566 24.1158V24.1158Z"
                        stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M26.8349 36.4221C34.2478 36.4221 40.2572 30.4128 40.2572 22.9999C40.2572 15.587 34.2478 9.57764 26.8349 9.57764H19.1651C11.7522 9.57764 5.74281 15.587 5.74281 22.9999C5.74281 30.4128 11.7522 36.4221 19.1651 36.4221H26.8349Z"
                        stroke="#FDA321" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p>“Қараңғы фон” жаңа функциясын қолданып көріңіз</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="shop">
      <div class="container">
        <div class="shop-header">
          <h2>Сатылымдағы кітаптар:</h2>
          <img src="@/assets/img/main/circle-green.svg" alt="круги">
        </div>
        <div class="card-list">
          <v-card-md
              v-for="(item, itemIdx) in products"
              :key="itemIdx"
              background="#EEF9FC"
              :title="item.name"
              :price="item.price"
              :desc="item.desc"
              :id="item.id"
              :img="item.image"
          >
          </v-card-md>
        </div>
        <router-link :to="{name: 'shop'}" class="btn btn-danger catalog-link">
          <span>Барлық кітаптар</span>
          <i class="icon chevron-right"></i>
        </router-link>
      </div>
    </section>
    <section ref="author" id="author" class="feedback">
      <div class="container">
        <div class="feedback-box">
          <h2>Автор болғым келеді</h2>
          <form class="feedback-form" @submit.prevent="submitAuthor">
            <v-custom-input
                placeholder="Есіміңізді жазыңыз"
                label="Есіміңіз"
                v-model.trim="name"
                type="text"
                :isLight="true"
                :error="errors.name"
                @keyup="clearForm('name')"
            ></v-custom-input>
            <v-custom-input
                placeholder="Телефон нөміріңіз"
                label="Телефон"
                v-model.trim="phone"
                type="text"
                :isLight="true"
                :data-maska="'8 ### ### ####'"
                :error="errors.phone"
                @keyup="clearForm('phone')"
            ></v-custom-input>
            <v-custom-input
                placeholder="Почтаңызды жазыңыз"
                label="Почта"
                v-model.trim="email"
                type="email"
                :isLight="true"
                :error="errors.email"
                @keyup="clearForm('email')"
            ></v-custom-input>
            <div class="submit-container">
              <p>"Өтініш қалдыру" батырмасын баса отырып сіз <a href="#" target="_blank">жеке деректерді өңдеу
                шарттарымен</a> келісесіз</p>
              <button type="submit" class="btn btn-light">
                <span>Өтініш қалдыру</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section ref="contact" id="contact" class="contact">
      <div class="container">
        <div class="row contact-row">
          <div class="col-sm-3 col-xl-4 contact-img">
            <img src="@/assets/img/main/gamepad.png" alt="фото джойстика">
          </div>
          <div class="col-sm-6 col-xl-4">
            <div class="contact-container">
              <h2>Бізбен байланыс</h2>
              <p>Бізді әлеуметтік желілерде бақылаңыз және соңғы жаңалықтардан хабардар болыңыз!</p>
              <ul class="social-list">
                <li>
                  <a target="_blank" href="https://instagram.com/ordagen.kz?igshid=1rqz7fe4xahgk"
                     style="background: #FA7264">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13 2.75904C16.3133 2.75904 16.7651 2.75904 18.1205 2.75904C19.3253 2.75904 19.9277 3.06024 20.3795 3.21084C20.9819 3.51205 21.4337 3.66265 21.8855 4.11446C22.3374 4.56627 22.6386 5.01807 22.7892 5.62048C22.9398 6.07229 23.0904 6.6747 23.241 7.87952C23.241 9.23494 23.241 9.53615 23.241 13C23.241 16.4639 23.241 16.7651 23.241 18.1205C23.241 19.3253 22.9398 19.9277 22.7892 20.3795C22.488 20.9819 22.3374 21.4337 21.8855 21.8855C21.4337 22.3374 20.9819 22.6386 20.3795 22.7892C19.9277 22.9398 19.3253 23.0904 18.1205 23.241C16.7651 23.241 16.4639 23.241 13 23.241C9.53615 23.241 9.23494 23.241 7.87952 23.241C6.6747 23.241 6.07229 22.9398 5.62048 22.7892C5.01807 22.488 4.56627 22.3374 4.11446 21.8855C3.66265 21.4337 3.36145 20.9819 3.21084 20.3795C3.06024 19.9277 2.90964 19.3253 2.75904 18.1205C2.75904 16.7651 2.75904 16.4639 2.75904 13C2.75904 9.53615 2.75904 9.23494 2.75904 7.87952C2.75904 6.6747 3.06024 6.07229 3.21084 5.62048C3.51205 5.01807 3.66265 4.56627 4.11446 4.11446C4.56627 3.66265 5.01807 3.36145 5.62048 3.21084C6.07229 3.06024 6.6747 2.90964 7.87952 2.75904C9.23494 2.75904 9.68675 2.75904 13 2.75904ZM13 0.5C9.53615 0.5 9.23494 0.5 7.87952 0.5C6.5241 0.5 5.62048 0.801206 4.86747 1.10241C4.11446 1.40362 3.36145 1.85542 2.60843 2.60843C1.85542 3.36145 1.55422 3.96386 1.10241 4.86747C0.801206 5.62048 0.650602 6.5241 0.5 7.87952C0.5 9.23494 0.5 9.68675 0.5 13C0.5 16.4639 0.5 16.7651 0.5 18.1205C0.5 19.4759 0.801206 20.3795 1.10241 21.1325C1.40362 21.8855 1.85542 22.6386 2.60843 23.3916C3.36145 24.1446 3.96386 24.4458 4.86747 24.8976C5.62048 25.1988 6.5241 25.3494 7.87952 25.5C9.23494 25.5 9.68675 25.5 13 25.5C16.3133 25.5 16.7651 25.5 18.1205 25.5C19.4759 25.5 20.3795 25.1988 21.1325 24.8976C21.8855 24.5964 22.6386 24.1446 23.3916 23.3916C24.1446 22.6386 24.4458 22.0361 24.8976 21.1325C25.1988 20.3795 25.3494 19.4759 25.5 18.1205C25.5 16.7651 25.5 16.3133 25.5 13C25.5 9.68675 25.5 9.23494 25.5 7.87952C25.5 6.5241 25.1988 5.62048 24.8976 4.86747C24.5964 4.11446 24.1446 3.36145 23.3916 2.60843C22.6386 1.85542 22.0361 1.55422 21.1325 1.10241C20.3795 0.801206 19.4759 0.650602 18.1205 0.5C16.7651 0.5 16.4639 0.5 13 0.5Z"
                          fill="white"/>
                      <path
                          d="M13 6.5241C9.38554 6.5241 6.5241 9.38554 6.5241 13C6.5241 16.6145 9.38554 19.4759 13 19.4759C16.6145 19.4759 19.4759 16.6145 19.4759 13C19.4759 9.38554 16.6145 6.5241 13 6.5241ZM13 17.2169C10.741 17.2169 8.78313 15.4096 8.78313 13C8.78313 10.741 10.5904 8.78313 13 8.78313C15.259 8.78313 17.2169 10.5904 17.2169 13C17.2169 15.259 15.259 17.2169 13 17.2169Z"
                          fill="white"/>
                      <path
                          d="M19.6265 7.87952C20.4583 7.87952 21.1325 7.20525 21.1325 6.3735C21.1325 5.54174 20.4583 4.86747 19.6265 4.86747C18.7948 4.86747 18.1205 5.54174 18.1205 6.3735C18.1205 7.20525 18.7948 7.87952 19.6265 7.87952Z"
                          fill="white"/>
                    </svg>
                  </a>
                </li>
                <!--                <li>-->
                <!--                  <a href="#" style="background: #FDA321">-->
                <!--                    <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                      <path-->
                <!--                          d="M24.4703 6.81697C22.7286 6.81693 21.0584 6.12503 19.8269 4.89348C18.5954 3.66194 17.9035 1.99163 17.9036 0.25H13.2119V18.6217C13.211 19.4593 12.9465 20.2754 12.4559 20.9543C11.9653 21.6332 11.2735 22.1405 10.4785 22.4043C9.68351 22.668 8.82566 22.6749 8.02656 22.4238C7.22745 22.1728 6.52761 21.6766 6.02625 21.0056C5.52488 20.3346 5.24742 19.5229 5.23318 18.6854C5.21894 17.8479 5.46865 17.0272 5.94691 16.3395C6.42518 15.6519 7.10774 15.1322 7.89786 14.8542C8.68797 14.5761 9.54556 14.5538 10.3491 14.7904V10.2296C8.64146 9.99939 6.90426 10.2956 5.36941 11.0786C3.83457 11.8617 2.57514 13.0943 1.75931 14.612C0.943474 16.1297 0.61006 17.8601 0.803588 19.5723C0.997117 21.2844 1.70838 22.8968 2.84239 24.194C3.97641 25.4913 5.47921 26.4117 7.15011 26.8324C8.82102 27.2531 10.5805 27.1541 12.1936 26.5485C13.8067 25.9429 15.1967 24.8595 16.1779 23.4432C17.1592 22.0268 17.6849 20.3448 17.685 18.6217L17.8219 9.33541C19.7496 10.7505 22.0794 11.5119 24.4707 11.5084L24.4703 6.81697Z"-->
                <!--                          fill="white"/>-->
                <!--                    </svg>-->
                <!--                  </a>-->
                <!--                </li>-->
                <li>
                  <a target="_blank" href="http://wa.me/77784659000" style="background: #4BB34B">
                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M22.9085 4.07812C20.439 1.61719 17.1463 0.25 13.6707 0.25C6.44512 0.25 0.591462 6.08333 0.591462 13.2839C0.591462 15.5625 1.23171 17.8411 2.32927 19.7552L0.5 26.5L7.45122 24.6771C9.37195 25.6797 11.4756 26.2266 13.6707 26.2266C20.8963 26.2266 26.75 20.3932 26.75 13.1927C26.6585 9.82031 25.378 6.53906 22.9085 4.07812ZM19.9817 17.9323C19.7073 18.6615 18.4268 19.3906 17.7866 19.4818C17.2378 19.5729 16.5061 19.5729 15.7744 19.3906C15.3171 19.2083 14.6768 19.026 13.9451 18.6615C10.6524 17.2943 8.54878 14.013 8.36586 13.7396C8.18293 13.5573 6.9939 12.0078 6.9939 10.3672C6.9939 8.72656 7.81707 7.99739 8.09146 7.63281C8.36585 7.26823 8.73171 7.26823 9.0061 7.26823C9.18902 7.26823 9.46341 7.26823 9.64634 7.26823C9.82926 7.26823 10.1037 7.17708 10.378 7.8151C10.6524 8.45312 11.2927 10.0938 11.3841 10.1849C11.4756 10.3672 11.4756 10.5495 11.3841 10.7318C11.2927 10.9141 11.2012 11.0964 11.0183 11.2786C10.8354 11.4609 10.6524 11.7344 10.561 11.8255C10.378 12.0078 10.1951 12.1901 10.378 12.4635C10.561 12.8281 11.2012 13.8307 12.2073 14.7422C13.4878 15.8359 14.4939 16.2005 14.8598 16.3828C15.2256 16.5651 15.4085 16.474 15.5915 16.2917C15.7744 16.1094 16.4146 15.3802 16.5976 15.0156C16.7805 14.651 17.0549 14.7422 17.3293 14.8333C17.6037 14.9245 19.25 15.7448 19.5244 15.9271C19.8902 16.1094 20.0732 16.2005 20.1646 16.2917C20.2561 16.5651 20.2561 17.2031 19.9817 17.9323Z"
                          fill="white"/>
                    </svg>
                  </a>
                </li>
                <!--                <li>-->
                <!--                  <a href="#" style="background: #25BBD6">-->
                <!--                    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                      <path-->
                <!--                          d="M24 0.752782L20.2432 20.3653C20.2432 20.3653 19.7176 21.7251 18.2736 21.073L9.60572 14.1907L9.56553 14.1704C10.7364 13.0817 19.8155 4.62833 20.2123 4.24515C20.8266 3.6517 20.4452 3.29841 19.732 3.7467L6.32099 12.5662L1.14705 10.7635C1.14705 10.7635 0.332822 10.4635 0.254491 9.81138C0.17513 9.15816 1.17384 8.80487 1.17384 8.80487L22.2664 0.236184C22.2664 0.236184 24 -0.552588 24 0.752782Z"-->
                <!--                          fill="white"/>-->
                <!--                    </svg>-->
                <!--                  </a>-->
                <!--                </li>-->
              </ul>
            </div>
          </div>
          <div class="col-sm-3 col-xl-4 contact-img">
            <img src="@/assets/img/main/tetris.png" alt="игровое устройство">
          </div>
        </div>
      </div>
    </section>
  </div>
  <v-success-modal
      v-show="showSuccessModal"
      title="Спасибо за вашу заявку"
      desc="Ваша заявка была принята. <br/> Скоро с вами свяжется наш менеджер."
      @close="closeSuccessModal"
  ></v-success-modal>
</template>

<script>
import VCardMd from '@/components/VCardMd';
import VCustomInput from '@/components/VCustomInput';
import VSuccessModal from '@/modals/VSuccessModal';


export default {
  name: "VHome",
  components: {
    VCardMd,
    VCustomInput,
    VSuccessModal
  },

  mounted() {
    this.fetchData();
    this.scroll();
  },

  data() {
    return {
      products: [],
      name: '',
      phone: '',
      email: '',
      showSuccessModal: false,
      errors: {
        name: null,
        phone: null,
        email: null,
      }
    }
  },

  methods: {
    scroll() {
      if (this.$route.hash) {
        let hash = this.$route.hash.replace('#', '')
        let element = this.$refs[hash];
        let top = element.offsetTop;
        window.scrollTo(0, top);
      }
    },

    async fetchData() {
      let res = await fetch('https://api.ordagen.com/web/products');
      let {data} = await res.json()
      this.products = data.data.slice(0, 4)
    },

    clearForm(name) {
      switch (name) {
        case 'name':
          if(this.name.length) {
            this.errors.name = null
          }
          break
        case 'phone':
          if(this.phone.length) {
            this.errors.phone = null
          }
          break
        case 'email':
          if(this.email.length) {
            this.errors.email = null
          }
          break
      }
    },

    formIsValid() {
      let isValid = true;
      if (this.name.length === 0) {
        isValid = false;
        this.errors.name = 'Есіміңіз міндетті түрде жазылуы тиіс'
      }
      if (this.phone.length === 0) {
        isValid = false;
        this.errors.phone = 'Телефон нөміріңіз міндетті түрде жазылуы тиіс'
      }
      if (this.email.length === 0) {
        isValid = false;
        this.errors.email = 'Почтаңыз міндетті түрде жазылуы тиіс'
      }
      return isValid
    },

    async submitAuthor() {
      if (this.formIsValid()) {
        const url = 'https://api.ordagen.com/api/become-author'
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: this.name,
            phone: this.phone,
            email: this.email
          })
        })
        if(!res.error) {
          this.showSuccessModal = true
          this.$store.state.modalOpen = true
          this.name = ''
          this.phone = null
          this.email = ''
        }
      }
    },

    closeSuccessModal() {
      this.showSuccessModal = false
      this.$store.state.modalOpen = false
    }
  }
}
</script>

<style scoped>

</style>
